// 枚举
export const finishedEnum = 1; // 成品
export const materialEnum = 2; // 原料
export const processedEnum = 3; // 加工品

// 加工状态
export const skuTypeOptions = [
    {
        label: '成品',
        value: 1,
    },
    {
        label: '原料',
        value: 2,
    },
    // {
    //     label: '加工品',
    //     value: 3,
    // },
];

/*
    自定义属性
    渲染状态
*/
export const extValueTypeMap = {
    /* input type=number */
    NUMBER: 1,
    /* input type=text */
    TEXT: 2,
    /* input type=radio */
    RADIO: 3,
    /* input type=checkbox */
    MULTI: 4,
};

/*
    自定义属性
    是否必填
*/
export const extRequiredTypeMap = {
    /* 否 */
    NO: 0,
    /* 是 */
    YES: 1,
};


// 审核状态
export const approvalStatusMap = {
    1: '待提交',
    2: '审核中',
    3: '被驳回',
    4: '审核通过',
    5: '已关闭',
};

export const auditStatusesOptions = [
    {
        label: '待审核',
        value: 1,
    },
    {
        label: '审核驳回',
        value: 3,
    },
    {
        label: '审核通过',
        value: 4,
    },
];
export const auditStatusMap = {
    1: '待审核',
    3: '审核驳回',
    4: '审核通过',
};

export const periodTypeEnum = {
    FOEVER: 1,
    TIME_PERIOD: 2,
};

// export const rejectNodeTypesEnum = {
//     // 采购驳回
//     CAIGOU_REJECT: 1,
//     // 运营驳回
//     YUNYING_REJECT: 2,
//     // 品控驳回
//     PINKONG_REJECT: 3,
// };

/* 上新相关公共配置 */

// 进项税列表
export const InputTaxList = [
    {
        label: '0%',
        value: '0',
    },
    {
        label: '1%',
        value: '1',
    },
    {
        label: '3%',
        value: '3',
    },
    {
        label: '6%',
        value: '6',
    },
    {
        label: '9%',
        value: '9',
    },
    {
        label: '13%',
        value: '13',
    },
];

// 扩展属性类型
export const ExtBusinessTypeMap = {
    BASE_INFO: 1, // 基础属性
    SALE_SPEC: 2, // 销售规格
    CITY_SALE: 3, // 城市售卖属性
    CITY_PURCHASE: 4, // 城市采购属性
    OPERATE: 5, // 运营内容属性
};

// 条形码类型
// export const skuCodeType = [
//     {
//         label: '标准条码',
//         value: 1,
//     },
//     {
//         label: '自编条码',
//         value: 2,
//     },
// ];

// 商品上新-销售渠道
// export const channelOfflineEnum = 1; // 线下门店
// export const channelAppEnum = 2; // APP小程序
// export const channelWmMarket = 3; // 外卖 商超
// export const channelWmDiet = 4; // 外卖 餐饮
// export const channelDefEnum = [channelOfflineEnum, channelAppEnum, channelWmMarket, channelWmDiet];

// 加工品的配送方式options
export const shipTypeOptionsInProcessed = [
    {
        label: '加工仓自加工，配送到站',
        value: 60,
    },
    {
        label: '站点自加工',
        value: 40,
    },
];

// 成品的配送方式
export const shipTypeOptionsInFinished = [
    {
        label: '直送到仓，配送到站',
        value: 20,
    },
    {
        label: '直送到仓，越库到站',
        value: 50,
    },
    {
        label: '直送到加工仓',
        value: 70,
    },
    {
        label: '直送到站',
        value: 10,
    },
    {
        label: '站点领用',
        value: 30,
    },
];

// 原料的配送方式
export const shipTypeOptionsInMaterial = [
    {
        label: '直送到仓，配送到站',
        value: 20,
    },
    {
        label: '直送到仓，越库到站',
        value: 50,
    },
    {
        label: '直送到站',
        value: 10,
    },
    {
        label: '直送到加工仓',
        value: 70,
    },
];

// export const citySaleWay = [
//     {
//         label: '线下门店', value: 1, allowBulk: true,
//     }, {
//         label: 'APP和小程序', value: 2, allowBulk: true,
//     }, {
//         label: '外卖-商超', value: 3, allowBulk: false,
//     }, {
//         label: '外卖-餐饮', value: 4, allowBulk: false,
//     },
// ];

// 属性管理--属性分类和管理层级映射
// export const extTypeLevelMap = {
//     // 全国
//     1: [
//         {
//             label: '基础属性',
//             value: 1,
//         },
//         {
//             label: '销售规格',
//             value: 2,
//         },
//         {
//             label: '内容属性',
//             value: 5,
//         },
//     ],
//     // 城市
//     2: [
//         {
//             label: '售卖属性',
//             value: 3,
//         },
//         {
//             label: '采购属性',
//             value: 4,
//         },
//     ],
//     // 门店
//     3: [
//         {
//             label: '仓储属性',
//             value: 6,
//         },
//     ],
// };
// 分类品类 物资枚举
// export const SuppliesEnum = 2;

// 资质类型
export const qualificationTypeMap = {
    13: '商品检测报告',
    14: '实物图',
    15: '商品报关单',
    16: '入境检疫证明',
};

/* 上新相关公共配置 */
